<script>
    import LandingPageFirstSection from './landingPageFirstSection.svelte';
    import LandingPageGamer from './landingPageGamer.svelte';
    import LandingPageHowSection from './landingPage_HowitWorks.svelte';
    import LandingPageStoryTeller from './landingPageStoryTeller.svelte';
    import LandingPagePerformer from './landingpagePerformers.svelte';
    import LandingPageFeature from './landingPageFeature.svelte';
    import LandingpageUpToDate from './landingpage_UpToDate.svelte';
    import LandingPageArtist from './landingPageArtist.svelte';
    // import LandingPageFirstSectionB from './landingPageFirstSectionB.svelte';
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';
    // import {fade} from 'svelte/transition';
    import StartingAnimationMobile from './mobile/startingAnimationMobile.svelte';
    let navbar;
    let flag = false;
    setTimeout(() => {
        flag = true;
    }, 5000);
    let position;
    let getSession;
    $: {
        if (getSession === false) {
            position = 'relative';
        } else if (getSession === true) {
            position = 'fixed';
        }
    }
</script>

<svelte:window bind:scrollY={navbar} />

{#if flag === false}
        <div>
            <StartingAnimationMobile />
        </div>
    {:else if flag === true}
        {#if navbar > 2 }
            <div class="navbar" >
                <MobileNavbar />
            </div>
            {/if}

    <div class="mainDiv" style="position: {position};">
        <div>
            <LandingPageFirstSection bind:getSession />
        </div>
        <div>
            <LandingPageGamer />
        </div>
        <div>
            <LandingPageArtist />
        </div>
        <div>
            <LandingPageStoryTeller />
        </div>
        <div>
            <LandingPagePerformer />
        </div>
        <div>
            <LandingPageHowSection />
        </div>
        <div>
            <LandingPageFeature />
        </div>
        <div>
            <LandingpageUpToDate />
        </div>
    </div>
{/if}

<style>
    .navbar {
        position: fixed;
        width: 100%;
        height: fit-content;
        z-index: 100;
        animation: slideup 1.6s forwards;
        /* animation: opacity 1.6s forwards; */
    }
    @keyframes slideup{
        0%{
            transform: translateY(30vw);
            opacity: 0;
        }
        70%{
            transform: translateY(0vw);
        }
        100%{
           
            opacity: 1;
        } 
    }
    .mainDiv {
        overflow: hidden;
        font-family: "Orbitron";
    }
</style>
